<template>
    <inline-tab-panel name="email">
        <flex-container direction="column">
            <input-group v-model="sendTime" :schema="date().required()">
                <template #label>
                    <flex-container :gap="Size.sm">
                        <input-label>
                            Hoe laat wil je de e-mail versturen?
                        </input-label>

                        <span v-if="false" v-tooltip.info="'Lorem ipsum'">
                            <svg-icon
                                :icon="IconCircleInfo"
                                :size="IconSize.sm"
                                is-custom-icon
                            />
                        </span>
                    </flex-container>
                </template>

                <template #input>
                    <date-input type="time" />
                </template>
            </input-group>
            <input-group v-model="subject" :schema="string().required()">
                <template #label>
                    <flex-container :gap="Size.sm">
                        <input-label>
                            Onderwerp
                        </input-label>

                        <span v-if="false" v-tooltip.info="'Lorem ipsum'">
                            <svg-icon
                                :icon="IconCircleInfo"
                                :size="IconSize.sm"
                                is-custom-icon
                            />
                        </span>
                    </flex-container>
                </template>

                <template #input>
                    <text-input placeholder="Wat komt er kijken bij het kopen van een woning?" />
                </template>
            </input-group>
            <input-group v-model="headerText" :schema="string().required()">
                <template #label>
                    <flex-container :gap="Size.sm">
                        <input-label>
                            Pre-header tekst
                        </input-label>

                        <span v-if="false" v-tooltip.info="'Lorem ipsum'">
                            <svg-icon
                                :icon="IconCircleInfo"
                                :size="IconSize.sm"
                                is-custom-icon
                            />
                        </span>
                    </flex-container>
                </template>

                <template #input>
                    <text-input placeholder="Onze handige tips ter voorbereiding" />
                </template>
            </input-group>
        </flex-container>
    </inline-tab-panel>
</template>

<script setup lang="ts">
    import {
        DateInput,
        FlexContainer,
        IconSize,
        InlineTabPanel,
        InputGroup,
        InputLabel,
        Size,
        SvgIcon,
        TextInput,
    } from '@keyvue/one-ui';

    import { ref, watch } from 'vue';
    import IconCircleInfo from '@keyvue/one-awesome-icons/icons/regular/circle-info.svg?component';
    import { date, string } from 'yup';

    interface Props {
        sendTime: string
        subject: string
        headerText: string
    }

    const props = defineProps<Props>();
    const emit = defineEmits<{
        (e: 'update:sendTime', sendTime: string): void;
        (e: 'update:subject', subject: string): void;
        (e: 'update:headerText', headerText: string): void;
    }>();

    const sendTime = ref(stringToDate(props.sendTime));
    const subject = ref(props.subject);
    const headerText = ref(props.headerText);

    function stringToDate(dateString: string): Date {
        return new Date(`1970-01-01T${dateString}:00`);
    }

    function dateToString(value: Date): string {
        return value.toTimeString().slice(0, 5);
    }

    watch(() => props.sendTime, (newTime) => {
        sendTime.value = stringToDate(newTime);
    });

    watch(() => props.subject, (newSubject) => {
        subject.value = newSubject;
    });

    watch(() => props.headerText, (newHeaderText) => {
        headerText.value = newHeaderText;
    });

    watch(sendTime, (newTime) => {
        emit('update:sendTime', dateToString(newTime));
    });

    watch(subject, (newSubject) => {
        emit('update:subject', newSubject);
    });

    watch(headerText, (newHeaderText) => {
        emit('update:headerText', newHeaderText);
    });
</script>
